module.exports = __webpack_public_path__ + "static/img/icon08.77b47c0a.svg";